import React from 'react'
import SpinnerAnimation from '../../../components/Spinner'

const Registration = ({
    username,
    password,
    passwordCheck,
    acceptTerms,
    onRegister,
    onSwitchToSignin,
    onChange,
    onFocus,
    errors,
    formSubmitted,
    validating
}) => (
    <div>
        <p>
            <input
                type         = "text"
                className    = { "login-control-username" + (errors.username ? " .error" : "") }
                autoComplete = "username"
                placeholder  = "Email address"
                value        = { username }
                onChange     = { onChange('username') }
                onFocus      = { onFocus('username', true) }
                onBlur       = { onFocus('username', false) }
                disabled     = { formSubmitted ? "disabled" : "" }
            />
        </p>
        <p className="password-field-container">
            <input
                type         = "password"
                className    = "login-control-pass"
                autoComplete = "password"
                placeholder  = "Password"
                value        = { password }
                onChange     = { onChange('password') }
                onBlur       = { onFocus('password', false) }
                disabled     = { formSubmitted ? "disabled" : "" }
            />
            <SpinnerAnimation className="password-validation-spinner" style={{ display: validating ? "" : "none" }}/>
        </p>
        <p>
            <input
                type         = "password"
                className    = "login-control-pass"
                autoComplete = "passwordCheck"
                placeholder  = "Confirm password"
                value        = { passwordCheck }
                onChange     = { onChange('passwordCheck') }
                onBlur       = { onFocus('passwordCheck', false) }
                disabled     = { formSubmitted ? "disabled" : "" }
            />
        </p>
        <p className="form-checkbox-wrapper">
            <input
                type="checkbox"
                id="acceptTerms"
                name="acceptTerms"
                checked={acceptTerms}
                onChange={onChange('acceptTerms')}
                disabled={formSubmitted ? "disabled" : ""}
                className={errors.acceptTerms ? 'error' : ''}
            />
            <label htmlFor="acceptTerms" style={{ fontSize: '13px', marginLeft: '8px', cursor: 'pointer' }}>
                I accept the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </label>
        </p>
        <p>
            <button autoFocus
                className = "login-submit"
                onClick   = { onRegister }
                disabled  = { (formSubmitted || errors.submit || errors.acceptTerms) ? "disabled" : "" }
            >
              {formSubmitted ? "Registering..." : "Register"}
              <SpinnerAnimation style={{ float: "right", display: formSubmitted ? "" : "none" }}/>
            </button>
        </p>
        <p className="signup-block">
            <button
                type = "button"
                className = "signup-btn"
                onClick = { onSwitchToSignin }
            >
                Back to sign-in
            </button>
        </p>
    </div>
)

export default Registration;
